import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section7: FC<{ onClickButton: () => void }> = ({ onClickButton }) => {
  return (
    <L_Section7>
      <Strong>궁금하신 클래스가 있다면 문의를 남겨주세요.</Strong>
      <div style={{ marginTop: '1rem' }}>상담 후 체험용 계정을 전달드립니다.</div>
      <div>
        <button onClick={onClickButton}>기업교육 문의하기</button>
      </div>
    </L_Section7>
  );
};
const L_Section7 = styled.section`
  text-align: center;
  margin-top: 8rem;
  background: ${palette.system.BLACK};
  font-size: 1.6rem;
  font-weight: 300;
  padding: 3rem 2rem 0 2rem;
  & > div {
    color: ${palette.grey50};
  }
  & > div > button {
    color: white;
    background-color: ${palette.Primary.Active};
    padding: 1rem 3rem;
    white-space: nowrap;
    border-radius: 0.5rem;
    font-weight: 600;
    margin: 3.6rem auto 0 auto;
    font-size: 1.6rem;
  }
  padding-bottom: 3rem;
`;
const Strong = styled.span`
  font-size: 2.4rem;
  font-weight: 600;
  color: ${palette.grey75};
`;

export default Section7;
